import React, { useEffect } from "react";
import { Box, Heading, Text, VStack, Icon, useColorModeValue } from "@chakra-ui/react";
import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NotAllowed = () => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.900");
  const iconColor = useColorModeValue("red.500", "red.400");

  useEffect(() => {
    // Automatically move to the landing page after 3 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box w="100%" h="100vh" bg={bg} display="flex" alignItems="center" justifyContent="center">
      <VStack spacing={6} p={8} bg={useColorModeValue("white", "gray.800")} rounded="xl" shadow="2xl" textAlign="center" maxW="md">
        <Icon as={FaLock} w={16} h={16} color={iconColor} />
        <Heading size="xl">Not Allowed</Heading>
        <Text fontSize="lg" color="gray.500">
          Your session has expired due to inactivity or you are not authorized to view this page.
        </Text>
        <Text fontSize="sm" color="gray.400">
          Redirecting to the landing page...
        </Text>
      </VStack>
    </Box>
  );
};

export default NotAllowed;
